import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { recommendationApiToRecommendationEntity } from '../../entities/Recommendation';
import { pagingMetadataToCursorResponse } from '../../utils/PagingUtils';
import { BaseClient } from '../BaseClient';
export class RecommendationsClientBase extends BaseClient {
  constructor() {
    super(...arguments);
    _defineProperty(this, "queryRecommendationsImpl", void 0);
    _defineProperty(this, "applyRecommendationImpl", void 0);
  }
  async queryRecommendations(query) {
    try {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      const {
        recommendations,
        pagingMetadata
      } = await this.request(this.queryRecommendationsImpl({
        query
      }), ...args);
      if (!recommendations) {
        throw new Error('Recommendations is not an array');
      }
      return {
        items: recommendations == null ? void 0 : recommendations.map(this.convertToEntity),
        ...pagingMetadataToCursorResponse(pagingMetadata)
      };
    } catch (error) {
      this.logError('queryRecommendations', 'Failed to query recommendations', {
        query
      }, error);
      throw error;
    }
  }
  async applyRecommendation(recommendationId) {
    try {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      await this.request(this.applyRecommendationImpl({
        recommendationId
      }), ...args);
    } catch (error) {
      this.logError('applyRecommendation', 'Failed to apply recommendation', {
        recommendationId
      }, error);
      throw error;
    }
  }
  convertToEntity(recommendation) {
    try {
      return recommendationApiToRecommendationEntity(recommendation);
    } catch (error) {
      this.logError('convertToEntity', 'Failed to convert recommendation', {
        recommendation
      }, error);
      throw error;
    }
  }
  getServiceNameForLogs() {
    return 'RecommendationsClient';
  }
}
//# sourceMappingURL=RecommendationsClientBase.js.map